import type { SxProps, Theme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../Buttons';
import { InlineAlert } from '../InlineAlert';

export interface StaleNoticeProps {
  readonly onRetry: () => void;
  readonly sx?: SxProps<Theme>;
}

export const StaleNotice: React.FC<StaleNoticeProps> = ({ onRetry, sx }) => {
  const { t } = useTranslation();
  return (
    <InlineAlert
      severity="info"
      role="status"
      sx={sx}
      message={t('common.showingSaved', 'You’re offline or the last refresh failed. Showing what was loaded before.')}
    >
      <Button intent="tertiary" onClick={onRetry}>
        {t('common.tryAgain', 'Try again')}
      </Button>
    </InlineAlert>
  );
};
